import _ from 'lodash'

import { LevelPlayJigsaw as Activity } from '.'

export const SLUG = 'jigsaw'
export const activity = {
  SLUG,
  interactionMode: {
    kind: 'continue',
    waitValidation: true
  },
  Component: Activity
}
